export const _PENDING = '_PENDING';
export const _FULFILLED = '_FULFILLED';
export const _REJECTED = '_REJECTED';



// WEBPACK FOOTER //
// ./constants/PromiseMiddleware.js